import { render } from "./avatar.vue?vue&type=template&id=50fe0119&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=50fe0119&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-50fe0119"

export default script